import {
  type MileageRatePresetConstructor,
  type MileageRatePresetTax,
} from '@webapp/modules/expense/entities/MileageRatePreset'
import {
  type MileageRatePresetApiModel,
  type MileageRatePresetTaxApiModel,
} from '../api-models/MileageRatePresetApiModel'

const mapTax = (tax: MileageRatePresetTaxApiModel): MileageRatePresetTax => ({
  id: tax.id,
  name: tax.name,
  percentage: tax.percentage,
  isDefault: tax.is_default,
  isActive: tax.active,
  isInclusive: tax.is_inclusive,
})

export const mapMileageRatePresetApiModel = (
  apiModel: MileageRatePresetApiModel
): MileageRatePresetConstructor => ({
  id: apiModel.id,
  name: apiModel.name,
  rate: Number.parseFloat(apiModel.rate),
  currency: apiModel.currency,
  unit: apiModel.unit,
  advisoryFuelRate:
    apiModel.advisory_fuel_rate === null
      ? null
      : Number.parseFloat(apiModel.advisory_fuel_rate),
  tax: apiModel.tax ? mapTax(apiModel.tax) : null,
})
